var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-menu",on:{"click":function($event){$event.stopPropagation();_vm.$emit('click-item', _vm.data)},"mouseenter":function($event){_vm.$emit('hover-item', _vm.data)}}},[_c('img',{class:[
			'img-menu',
			{ 'applying-filters': _vm.iconCategory },
			{ 'active': _vm.data.select && _vm.iconCategory } ],attrs:{"src":_vm.data.webImage}}),_vm._v(" "),_c('span',{staticClass:"item-text",style:(_vm.data.select ? "color: white" : ("color: " + (_vm.globalColors.title) + ";transition:all 200ms ease-in;"))},[_vm._v(_vm._s(_vm.data.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ab1b08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/item-menu.vue
// module id = 903
// module chunks = 5 21